import { PRICING_API_URL } from "@umami/chains";

/**
 * Proxies external URLs through the pricing API image proxy to prevent IP leakage.
 * Only proxies http/https URLs; IPFS and data URLs are returned unchanged.
 */
export const getProxyUrl = (url: string | undefined): string | undefined => {
  if (!url) {
    return undefined;
  }

  // Proxy http/https URLs through PRICING_API_URL
  if (PRICING_API_URL && (url.startsWith("http://") || url.startsWith("https://"))) {
    return `${PRICING_API_URL}/image-proxy?url=${encodeURIComponent(url)}`;
  }

  return url;
};
